import { Link, useLocation } from "react-router-dom";
import { Button } from "../../../component/form";

const Fail = () => {
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const reason = query.get("reason");
    return (
        // <h1 className="text-center mt-5 text-danger">Payment Fail !</h1>
        <div className="flex flex-col items-center justify-center min-h-screen text-center bg-red-50">
            <h1 className="text-4xl font-bold text-red-600 mb-4">Payment Failed ❌</h1>
            <p className="text-lg">Oops! Something went wrong with your transaction.</p>
            {reason && <p className="mt-2 text-sm text-gray-600">Reason: {reason}</p>}
            <Link to='http://13.235.137.221/hollypills_web_stage/healthplan' className="text-center mt-5">Home</Link>
        </div>
    )
}

export default Fail